import { useHyperTestProjectName } from 'hooks/HypertestJobDetail/useHyperTestProjectName';
import { LTTooltip } from '@lambdatestincprivate/lt-components';
import LTText from 'components/LTComponents/LTText/LTText';

function HeaderTitle() {
  const {
    showProjectName,
    fullProjectName,
    truncatedProjectName,
    exceedsCharLimit,
  } = useHyperTestProjectName();

  if (!showProjectName) {
    return 'HyperExecute';
  }

  if (exceedsCharLimit) {
    return (
      <LTTooltip
        className="hyp-common-header-title"
        text={`${fullProjectName}`}
      >
        <LTText
          color="#1f2328"
          size={14}
          weight={600}
          lineHeight={20}
          as="span"
        >{`HyperExecute / ${truncatedProjectName}`}</LTText>
      </LTTooltip>
    );
  }

  return (
    <LTText
      color="#1f2328"
      size={14}
      weight={600}
      lineHeight={20}
      as="span"
    >{`HyperExecute / ${fullProjectName}`}</LTText>
  );
}

export default HeaderTitle;
